import { ImageData } from "../imageCollections";
import { BuyLink } from "./BuyLink";

interface DescriptionProps {
  painting: ImageData;
}

export default function Description({ painting }: DescriptionProps) {
  return (
    <div>
      {painting.medium} {painting.size} inches<br />
      {painting.price ? `$${painting.price}` : ""}<br />
      {painting.buyLink && <BuyLink href={painting.buyLink} />}
    </div>
  );
}
